import { render } from "./mutiplepictures.vue?vue&type=template&id=059e84b6&scoped=true"
import script from "./mutiplepictures.vue?vue&type=script&lang=js"
export * from "./mutiplepictures.vue?vue&type=script&lang=js"

import "./mutiplepictures.vue?vue&type=style&index=0&id=059e84b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059e84b6"]])

export default __exports__